// Angular
import { Injectable } from '@angular/core';

/**
 * Result of a limit-amount validation
 */
export interface ILimitValidation {
  valid: boolean;
  message?: string;
}

// Business rules for the Wagering Limits inputs
export const MAX_WAGER_LIMIT = 65000;
export const MIN_DAILY_LOSS_LIMIT = 50;

/**
 * Pure validation logic for the Wagering Limits component.
 */
@Injectable({ providedIn: 'root' })
export class WageringLimitsService {
  /**
   * Validate the bet-limit amount
   * @param {string | number} amount Raw input value
   * @returns {ILimitValidation} Validation result with optional message
   */
  validateWagerLimit(amount: string | number): ILimitValidation {
    if (amount === '' || amount === null || amount === undefined)
      return { valid: false, message: 'Please insert a number' };

    if (Number(amount) > MAX_WAGER_LIMIT)
      return {
        valid: false,
        message: `The entered amount exceeds the limit of $${MAX_WAGER_LIMIT}`
      };

    return { valid: true };
  }

  /**
   * Validate the NY daily-loss-limit amount
   * @param {string | number} amount Raw input value
   * @returns {ILimitValidation} Validation result with optional message
   */
  validateDailyLossLimit(amount: string | number): ILimitValidation {
    if (amount === '' || amount === null || amount === undefined)
      return { valid: false, message: 'Please insert a number' };

    if (Number(amount) < MIN_DAILY_LOSS_LIMIT)
      return { valid: false, message: `Amount must be $${MIN_DAILY_LOSS_LIMIT} or higher` };

    return { valid: true };
  }
}
